//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, createNamespacedHelpers } from 'vuex'
const VFacebookLogin = () => import('vue-facebook-login-component')

import axios from 'axios'
import makeDebug from 'debug'
import md5 from 'md5'
import { V_FACEBOOK_LOGIN } from '@/scripts/constants/css-classes'
const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
const debug = makeDebug('facebook-login')

export default {
  name: 'rb-facebook-login',
  components: {
    VFacebookLogin,
  },
  props: {
    sectionLogin: String,
    catEntry: String,
    isCmsRegistration: {
      type: Boolean,
      default: false,
    },

    isFrameAdvisor: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    FB: {},
    model: {},
    scope: {},
    fbUserDetail: {
      isLogged: false,
      userId: '',
      firstName: '',
      lastName: '',
      email: '',
      birthday: '',
      dayOfBirth: '',
      monthOfBirth: '',
      yearOfBirth: '',
    },
    paramsFacebook: {
      authorizationProvider: 'facebook',
      accessToken: '',
      pageName: 'ProductPage',
      endPointOauthFb: '',
    },
    appId: undefined,
  }),
  computed: {
    ...mapGetters(['storeConfig', 'translation']),

    ...mapGettersPdp(['ui', 'selectedProduct', 'privateSale']),
    getAppId() {
      return this.appId
    },
  },
  beforeMount: async function () {
    if (this.selectedProduct.isSemiPrivateSale || this.isCmsRegistration || this.isFrameAdvisor) {
      const { storeId } = this.storeConfig
      const urlGetApplicationID =
        window.location.origin + '/wcs/resources/store/' + storeId + '/loginidentity/oauth'
      await axios
        .post(urlGetApplicationID, {
          authorizationProvider: 'facebook',
        })
        .then((response) => {
          this.appId = response.data.clientId
        })
        .catch(function (error) {
          debug(error)
        })

      //Created for test purposes, should be removed in production
      // this.appId = 226923329158665
    }
  },
  methods: {
    onLoginFacebook(res) {
      const { storeId } = this.storeConfig

      if (res === undefined) {
        return
      }

      this.paramsFacebook.endPointOauthFb =
        window.location.origin + '/wcs/resources/store/' + storeId + '/loginidentity/oauth_validate'

      if (res.status === 'connected' && res.authResponse.accessToken) {
        this.paramsFacebook.accessToken = res.authResponse.accessToken

        if (this.sectionLogin === 'private_sale_login') {
          this.getUserData('emitLogin')
        } else if (this.sectionLogin === 'private_sale_register') {
          this.getUserData('emitRegister')
        }
      }
    },
    onLogoutFacebook() {
      if (this.sectionLogin === 'private_sale_register') {
        this.resetUserData('emitRegister')
      }
      this.FB.api('/me/permissions', 'delete', null, () => {
        this.FB.logout()
        this.model.connected = false
        this.model.disconnected = true
      })
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB
      this.scope = scope
      const faceBookLoginElList = document.getElementsByClassName(V_FACEBOOK_LOGIN)

      faceBookLoginElList.forEach((faceBookLoginEl) => {
        let dataElementId = ''
        if (faceBookLoginEl) {
          // TODO: pass login/register information through props
          /* if (this.privateSale.showLoginForm) {
            dataElementId = 'X_X_PrivateSaleLogin_FacebookLogin'
          } else if (this.privateSale.showRegisterForm) {
            dataElementId = 'X_X_PrivateSaleRegister_FacebookLogin'
          } */
          faceBookLoginEl.setAttribute('data-element-id', dataElementId)
        }
      })
    },
    getUserData(typeEmit = '') {
      this.FB.api(
        '/me',
        'GET',
        { fields: 'id,name,email,birthday,first_name,last_name' },
        (user) => {
          this.fbUserDetail.isLogged = true
          this.fbUserDetail.userId = user.id
          this.fbUserDetail.firstName = user.first_name
          this.fbUserDetail.lastName = user.last_name
          this.fbUserDetail.email = user.email
          this.fbUserDetail.birthday = user.birthday

          if (user.birthday) {
            let splitBirthday = user.birthday.split('/')
            this.fbUserDetail.dayOfBirth = '' + parseInt(splitBirthday[1])
            this.fbUserDetail.monthOfBirth = '' + parseInt(splitBirthday[0])
            this.fbUserDetail.yearOfBirth = '' + parseInt(splitBirthday[2])
          } else {
            this.fbUserDetail.birthday = ''
            this.fbUserDetail.dayOfBirth = ''
            this.fbUserDetail.monthOfBirth = ''
            this.fbUserDetail.yearOfBirth = ''
          }

          let dataRegisterByFacebook = {
            userData: this.fbUserDetail,
            paramsFacebook: {
              authorizationProvider: this.paramsFacebook.authorizationProvider,
              accessToken: this.paramsFacebook.accessToken,
              pageName: this.paramsFacebook.pageName,
              endPointOauthFb: this.paramsFacebook.endPointOauthFb,
            },
          }

          if (typeEmit === 'emitLogin') {
            this.$emit('eventFacebookLogin', dataRegisterByFacebook)
            this.onLogoutFacebook
          } else if (typeEmit === 'emitRegister') {
            this.$emit('eventFacebookRegister', dataRegisterByFacebook)

            let emailMd5 = ''
            if (this.fbUserDetail.email) {
              emailMd5 = md5(this.fbUserDetail.email)
            }

            this.$ma.trackEvent({
              event: 'Register',
              value: {
                Events_UserAccountNew: '1',
                Events_UserEmailSub: 'false',
                User_LoginType: 'Facebook',
                User_Email_MD5: emailMd5,
                User_Id: this.fbUserDetail.userId,
              },
            })
            this.onLogoutFacebook
          }
        }
      )
    },
    resetUserData(typeEmit = '') {
      this.fbUserDetail.isLogged = false
      this.fbUserDetail.userId = ''
      this.fbUserDetail.firstName = ''
      this.fbUserDetail.lastName = ''
      this.fbUserDetail.email = ''
      this.fbUserDetail.birthday = ''
      this.fbUserDetail.dayOfBirth = ''
      this.fbUserDetail.monthOfBirth = ''
      this.fbUserDetail.yearOfBirth = ''

      if (typeEmit === 'emitRegister') {
        this.$emit('eventFacebookRegister', this.fbUserDetail)
      }
    },
  },
}
